import { PAGE_TYPE } from 'constants/general';
import { TRIGGER_EVENTS } from 'constants/modal';

class AnalyticsService {
  /**
   * Map trigger event to analytics event category
   * @param {string} triggerEvent - Trigger event from TRIGGER_EVENTS constants
   * @returns {string} Event category name
   */
  static getEventCategory(triggerEvent) {
    switch (triggerEvent) {
      case TRIGGER_EVENTS.EXIT_INTENT:
        return 'Exit Intent';
      case TRIGGER_EVENTS.PAGE_DEPTH:
        return 'Scroll Depth';
      case TRIGGER_EVENTS.TIMED:
        return 'Time Based';
      case TRIGGER_EVENTS.BUTTON_LINK_CLICK:
        return 'Button / Link Click';
      default:
        return 'Unknown';
    }
  }
  /**
   * Push event to dataLayer for GTM
   * @param {string} eventName - GTM event name
   * @param {Object} eventData - Event data object
   */
  static pushEvent(eventName, eventData) {
    AnalyticsService._pushToDataLayer({ event: eventName, ...eventData });
  }

  static pushData(key, value) {
    AnalyticsService._pushToDataLayer({ [key]: value });
  }

  static _pushToDataLayer(data) {
    window.dataLayer = window.dataLayer || [];

    if (typeof window !== 'undefined' && data) {
      window.dataLayer.push(data);
    }
  }

  /**
   * Track promo popup impression
   * @param {string} modalName - Name/title of the modal
   * @param {string} triggerEvent - Trigger event from TRIGGER_EVENTS constants
   */
  static trackPromoPopupImpression(modalName, triggerEvent) {
    this.pushEvent('promoPopup', {
      eventType: 'Impression',
      eventCategory: this.getEventCategory(triggerEvent),
      modal_name: modalName,
      isConfirmed: undefined,
    });
  }

  /**
   * Track promo popup click
   * @param {string} modalName - Name/title of the modal
   * @param {string} triggerEvent - Trigger event from TRIGGER_EVENTS constants
   * @param {boolean} isConfirmed - True if user confirmed/agreed, false if cancelled/closed
   */
  static trackPromoPopupClick(modalName, triggerEvent, isConfirmed) {
    this.pushEvent('promoPopup', {
      eventType: 'Click',
      eventCategory: this.getEventCategory(triggerEvent),
      modal_name: modalName,
      eventValue: isConfirmed,
    });
  }

  /**
   * Track page load
   * @param {Object} params
   * @param {string} params.pageType
   * @param {string} [params.campaignPageType] - Campaign page subtype (e.g., 'Brand', 'Offer', 'Paid Search', 'Partnership')
   */
  static trackPageDataLoaded({ pageType, campaignPageType }) {
    const isCampaignPage = pageType === PAGE_TYPE.CAMPAIGN;

    this.pushEvent('page_data_loaded', {
      is_campaign_page: isCampaignPage,
      page_type: isCampaignPage ? PAGE_TYPE.CAMPAIGN : null,
      campaign_page_type: campaignPageType || null,
    });
  }
}

export default AnalyticsService;
